module.exports = __webpack_public_path__ + "img/Kazakhstan.3b0cb2ee.png";